import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.cms.gov/training-education/partner-outreach-resources/new-medicare-card/providers-office-managers",
  target: "_blank"
}, "Click here for CMS guidelines on the new Medicare Beneficiary Identifier (MBI)", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, [
  /*#__PURE__*/_createTextVNode(" MBI usage is required for all Medicare patients. Contact the patient or representative to obtain the 11-digit MBI provided on the patient's Medicare card, and enter it in the patient's chart. If the patient is unaware of his/her MBI, your "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cms.gov/mac-info",
    target: "_blank"
  }, "Medicare Administrative Contractor's provider portal"),
  /*#__PURE__*/_createTextVNode(" can be used to look up MBIs. ")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "referral-medicare-beneficiary-identifier" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0063"),
  /*#__PURE__*/_createTextVNode(" Medicare Beneficiary Identifier (MBI) Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_8 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "input-group-prepend flex" }
const _hoisted_12 = { class: "input-group-text form-check mb-0 rounded-0 px-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-medicare-beneficiary-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "N/A ")
], -1 /* HOISTED */)
const _hoisted_14 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "referral-health-insurance-claim" }, " Health Insurance Claim (HIC) Number ", -1 /* HOISTED */)
const _hoisted_16 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_17 = { class: "flex-grow-1" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "input-group-prepend flex" }
const _hoisted_20 = { class: "input-group-text form-check mb-0 rounded-0 px-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-health-insurance-claim-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "N/A ")
], -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "referral-medicaid-number" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0065"),
  /*#__PURE__*/_createTextVNode(" Medicaid Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_24 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_25 = { class: "flex-grow-1" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "input-group-prepend flex" }
const _hoisted_28 = { class: "input-group-text form-check mb-0 rounded-0 px-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-medicaid-number-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "N/A ")
], -1 /* HOISTED */)
const _hoisted_30 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "referral-alternate-medicaid-number" }, " Alternate Medicaid Number ", -1 /* HOISTED */)
const _hoisted_32 = { class: "input-group d-flex w-100 flex-nowrap" }
const _hoisted_33 = { class: "flex-grow-1" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "input-group-prepend flex" }
const _hoisted_36 = { class: "input-group-text form-check mb-0 rounded-0 px-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-alternate-medicaid-number-na"
}, [
  /*#__PURE__*/_createElementVNode("small", null, "N/A ")
], -1 /* HOISTED */)
const _hoisted_38 = { class: "mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "Verify Medicare Eligibility", -1 /* HOISTED */)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2 mt-4" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Primary Insurance")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_42 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "referral-primary-insurance" }, [
  /*#__PURE__*/_createTextVNode(" Primary: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Primary Insurance", -1 /* HOISTED */)
const _hoisted_45 = ["value"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Secondary Insurance")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_47 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "referral-secondary-insurance" }, " Secondary: ", -1 /* HOISTED */)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Secondary Insurance", -1 /* HOISTED */)
const _hoisted_50 = ["value"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-100 my-2" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " Tertiary Insurance")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_52 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "referral-tertiary-insurance" }, " Tertiary: ", -1 /* HOISTED */)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Tertiary Insurance", -1 /* HOISTED */)
const _hoisted_55 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Medicare = _resolveComponent("Medicare")!
  const _component_Medicaid = _resolveComponent("Medicaid")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Payer Information",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-medicare-beneficiary-identifier",
                      maxlength: "11",
                      class: _normalizeClass(`form-control h-100 no-border-radius ${
                                                _ctx.v$.referral.Insurance.MbiNumber.$error ||
                                                _ctx.errors.Insurance.includes('MbiNumber')
                                                    ? 'border border-warning'
                                                    : ''
                                            }`),
                      type: "text",
                      disabled: _ctx.referral.Insurance.IsMbiNA,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.Insurance.MbiNumber) = $event)),
                      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.MbiNumber.$touch && _ctx.v$.referral.Insurance.MbiNumber.$touch(...args))),
                      onChange: _cache[2] || (_cache[2] = (e)=>_ctx.handleAllInput('MbiNumber',e.target.value))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_10), [
                      [_vModelText, _ctx.referral.Insurance.MbiNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input ms-0 mt-0",
                        id: "referral-medicare-beneficiary-na",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.Insurance.IsMbiNA) = $event)),
                        onChange: _cache[4] || (_cache[4] = (e)=>_ctx.handleAllInput('MbiNumber',_ctx.referral.Insurance.IsMbiNA? 'MbiNA': null ))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.referral.Insurance.IsMbiNA]
                      ]),
                      _hoisted_13
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-health-insurance-claim",
                      class: "form-control h-100 no-border-radius",
                      type: "text",
                      disabled: _ctx.referral.Insurance.IsHicNA,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.Insurance.HicNumber) = $event))
                    }, null, 8 /* PROPS */, _hoisted_18), [
                      [_vModelText, _ctx.referral.Insurance.HicNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input ms-0 mt-0",
                        id: "referral-health-insurance-claim-na",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.Insurance.IsHicNA) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.referral.Insurance.IsHicNA]
                      ]),
                      _hoisted_21
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("span", null, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-medicaid-number",
                      class: _normalizeClass(`form-control h-100 no-border-radius ${
                                                _ctx.v$.referral.Insurance.MedicaidNumber.$error ||
                                                _ctx.errors.Insurance.includes('MedicaidNumber')
                                                    ? 'border border-warning'
                                                    : ''
                                            }`),
                      type: "text",
                      disabled: _ctx.referral.Insurance.IsMedicaidNA,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.Insurance.MedicaidNumber) = $event)),
                      onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.MedicaidNumber.$touch && _ctx.v$.referral.Insurance.MedicaidNumber.$touch(...args))),
                      onChange: _cache[9] || (_cache[9] = (e)=>_ctx.handleAllInput('MedicaidNumber',e.target.value))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_26), [
                      [_vModelText, _ctx.referral.Insurance.MedicaidNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input ms-0 mt-0",
                        id: "referral-medicaid-number-na",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.Insurance.IsMedicaidNA) = $event)),
                        onChange: _cache[11] || (_cache[11] = (e)=>_ctx.handleAllInput('MedicaidNumber',_ctx.referral.Insurance.IsMedicaidNA? 'MedicaidNA': null ))
                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.referral.Insurance.IsMedicaidNA]
                      ]),
                      _hoisted_29
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("span", null, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      name: "referral-alternate-medicaid-number",
                      class: "form-control h-100 no-border-radius",
                      type: "text",
                      disabled: _ctx.referral.Insurance.IsAlternateMedicaidNA,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.Insurance.AlternateMedicaidNumber) = $event))
                    }, null, 8 /* PROPS */, _hoisted_34), [
                      [_vModelText, _ctx.referral.Insurance.AlternateMedicaidNumber]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input ms-0 mt-0",
                        id: "referral-alternate-medicaid-number-na",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.referral.Insurance.IsAlternateMedicaidNA) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.referral.Insurance.IsAlternateMedicaidNA]
                      ]),
                      _hoisted_37
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("button", {
                    class: "btn btn-xs btn-primary p-1",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.verifyEligibility()))
                  }, _hoisted_40)
                ])
              ])
            ]),
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(`form-select ${
                                    _ctx.v$.referral.Insurance.PrimaryInsurance.$error ||
                                    _ctx.errors.Insurance.includes('PrimaryInsurance')
                                        ? 'border border-warning'
                                        : ''
                                }`),
                name: "referral-primary-insurance",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.referral.Insurance.PrimaryInsurance) = $event)),
                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setMedicareOrMedicaid(_ctx.referral.Insurance.PrimaryInsurance, 'primary'))),
                onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Insurance.PrimaryInsurance.$touch && _ctx.v$.referral.Insurance.PrimaryInsurance.$touch(...args)))
              }, [
                _hoisted_44,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.primaryInsurance, (status, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: status.value
                  }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_45))
                }), 128 /* KEYED_FRAGMENT */))
              ], 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelSelect, _ctx.referral.Insurance.PrimaryInsurance]
              ])
            ]),
            (_ctx.isPrimaryMedicare)
              ? (_openBlock(), _createBlock(_component_Medicare, {
                  key: 0,
                  type: "Primary"
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.isPrimaryMedicaid)
              ? (_openBlock(), _createBlock(_component_Medicaid, {
                  key: 1,
                  type: "Primary",
                  options: _ctx.referralOptions
                }, null, 8 /* PROPS */, ["options"]))
              : _createCommentVNode("v-if", true),
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                name: "referral-secondary-insurance",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.referral.Insurance.SecondaryInsurance) = $event)),
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setMedicareOrMedicaid(_ctx.referral.Insurance.SecondaryInsurance, 'secondary')))
              }, [
                _hoisted_49,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.secondaryInsurance, (status, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: status.value
                  }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_50))
                }), 128 /* KEYED_FRAGMENT */))
              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Insurance.SecondaryInsurance]
              ])
            ]),
            (_ctx.isSecondaryMedicare)
              ? (_openBlock(), _createBlock(_component_Medicare, {
                  key: 2,
                  type: "Secondary"
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.isSecondaryMedicaid)
              ? (_openBlock(), _createBlock(_component_Medicaid, {
                  key: 3,
                  type: "Secondary",
                  options: _ctx.referralOptions
                }, null, 8 /* PROPS */, ["options"]))
              : _createCommentVNode("v-if", true),
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                name: "referral-tertiary-insurance",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.referral.Insurance.TertiaryInsurance) = $event)),
                onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setMedicareOrMedicaid(_ctx.referral.Insurance.TertiaryInsurance, 'tertiary')))
              }, [
                _hoisted_54,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralOptions?.tertiaryInsurance, (status, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: status.value
                  }, _toDisplayString(status.text), 9 /* TEXT, PROPS */, _hoisted_55))
                }), 128 /* KEYED_FRAGMENT */))
              ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.Insurance.TertiaryInsurance]
              ])
            ]),
            (_ctx.isTertiaryMedicare)
              ? (_openBlock(), _createBlock(_component_Medicare, {
                  key: 4,
                  type: "Tertiary"
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.isTertiaryMedicaid)
              ? (_openBlock(), _createBlock(_component_Medicaid, {
                  key: 5,
                  type: "Tertiary",
                  options: _ctx.referralOptions
                }, null, 8 /* PROPS */, ["options"]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}